/* ******************************************************************************************************
 * This is a temporary component that maps all of our commonly used fontawesome icons to their
 * lucide-react counterpart. Once the transition is finalized, this may be removed
 *
 * @format
 */

import {
    LoaderPinwheel,
    FileQuestion,
    CheckCircle,
    PackageOpen,
    DollarSign,
    CircleHelp,
    Paintbrush,
    Hourglass,
    Recycle,
    Printer,
    Layers,
    Rewind,
    Clock,
    Phone,
    Truck,
    Info,
    Grid,
    X
} from 'lucide-react';

export const mapFaIconToLucideReact = {
    'fa-superpowers': LoaderPinwheel,
    'fa-check-double': CheckCircle,
    'fa-paint-brush': Paintbrush,
    'fa-object-group': Layers,
    'fa-question': CircleHelp,
    'fa-hourglass': Hourglass,
    'fa-dropbox': PackageOpen,
    'fa-check': CheckCircle,
    'fa-clock-o': Clock,
    'fa-dollar': DollarSign,
    'fa-backward': Rewind,
    'fa-recycle': Recycle,
    'fa-print': Printer,
    'fa-truck': Truck,
    'fa-phone': Phone,
    'fa-info': Info,
    'fa-th': Grid,
    'fa-ban': X,
    // default
    none: FileQuestion
};

export const IconFaToLucide = ({icon, ...restOfProps}) => {
    const IconComponent = mapFaIconToLucideReact[icon];

    return <IconComponent {...restOfProps} />;
};
